import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for PlanConversionStore, for use in the registry */ export const PlanConversionStoreActionTypes = [
    ActionType.AcquireProjectTrialAndConvertPlanAction,
    ActionType.PlanConversionSucceededAction,
    ActionType.ConvertPlanToPremiumAction,
    ActionType.ConvertPlanToPremiumSucceededAction,
    ActionType.ConvertPlanToPremiumFailedAction,
    ActionType.FetchConvertPlanStatusSucceededAction,
    ActionType.FetchConvertPlanStatusFailedAction,
    ActionType.RecordPlanForPlanUpgradedFREAction,
    ActionType.ResetPlanConversionStatusAction,
    ActionType.TrackConversionProgressAction
];
